<div class="col-sm-12 ficheTransporteur" 
     *ngIf="!isEmpty && !afficherWinTarifTransporteur && !afficherWinTransporteurLogo" style="height: 100%;">
  <div *ngIf="!isEmpty && !afficherWinTarifTransporteur && !afficherWinTransporteurLogo" class="header fiche">
    <div class="col-sm-6 fiche-client" style="padding: 0 15px;">
      <h2 *ngIf="transporteur.id">
        Modification de : {{ transporteur.nom || ''}}</h2>
      <h2 *ngIf="!transporteur.id">
        Création de transporteur
      </h2>
    </div>
    <div class="col-sm-6 text-right" style="padding-right: 0;">
      <button class="btn-header uppercase" id="log" *ngIf="showbtnLog && transporteur.id && transporteur.id > 0"
              (click)="common.getLogs(transporteur.id, '36', modalService);">
        Log
      </button>
      <button class="btn-header uppercase" (click)="returnList()" id="close2">
        Fermer
      </button>
      <button class="btn-header uppercase actionPricipal" id="valide2" (click)="save()">
        Valider
      </button>
    </div>
  </div>
  <mat-divider *ngIf="!isEmpty && !afficherWinTarifTransporteur && !afficherWinTransporteurLogo"></mat-divider>
  <div *ngIf="!isEmpty && !afficherWinTarifTransporteur && !afficherWinTransporteurLogo"
       class="paramsociete article paramIndice contente" style="overflow-y: auto;">
    <div class="col-sm-12 info-client" style="padding: 0;">
      <div class="group1 col-sm-12 tab-content" style="padding-top: 10px;">
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Nom du transporteur :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.nom"
                   [disabled]="isAppartientHolding && isParametrageTransporteur && ((depuisEcodechet && transporteur.id) || !depuisEcodechet)">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">
            Adresse :
          </label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.adresse1">
            <input type="text" class="form-control" [(ngModel)]="transporteur.adresse2"
                   style="margin-top: 5px; margin-bottom: 5px;">
            <input type="text" class="form-control" [(ngModel)]="transporteur.adresse3">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">
            Code Postal :
          </label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <app-autocomplete-cp-ville [cp]="'CP'" [item]="transporteur" [ville]="'ville'" [iscp]="true">
            </app-autocomplete-cp-ville>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">
            Ville :
          </label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <app-autocomplete-cp-ville [cp]="'CP'" [item]="transporteur" [ville]="'ville'"></app-autocomplete-cp-ville>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">Pays :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <app-autocomplete (selectfunction)="transporteur.pays = $event; transporteur.paysObjet = $event;"
                              [results]="listPays" [highlight]="true" [deleteSelectedValue]="true"
                              [id]="'modedepaie'" [defaultselected]="transporteur.paysObjet"
                              (searchfunction)="filterPays($event)" [selectvalue]="true"
                              [defaultsearch]="transporteur.paysObjet ? (transporteur.paysObjet.libelle || transporteur.paysObjet.libelleObjetEntite) : ''"></app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">Tel :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.Tel">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Fax :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.Fax">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Mail :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.Mail">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Tarif transporteur :</label>
          <div class="col-sm-9 champ text-underline historique" style="padding: 0 15px"
               (click)="modifierTarifTransporteur()">
            Définir
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Tampon / Signature :</label>
          <div class="col-sm-9 champ text-underline historique" [ngClass]="{'disabledbutton': !transporteur.id}" style="padding: 0 15px"
               (click)="modifierLogoTransporteur()">
            Définir
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">Siret :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.siren">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">TVA Intra :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.tvaIntra">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Département :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.dep">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Récépissé :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.recepisse">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">Date de validité :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <!-- <input type="text" class="form-control" [(ngModel)]="transporteur.validite"> -->
            <app-input-date [class]="'form-control'" [id]="'date'" [model]="dateValidite"
                            (changefct)="dateValidite = $event; changeDate($event);" [placeholder]="'Date de validité'"
                            (keyenterfct)="dateValidite = $event;changeDate($event);"
                            (selectfct)="selectDate($event, '#date');"
                            [showDatepicker]="true"></app-input-date>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Contact :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.contact">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Tel Contact :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.telContact">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Code professionnel :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.codeProfessionnel">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px"> Code  sécurité :</label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="transporteur.tokenTrackdechet"  maxlength="4" pattern="\\d{4}"
            (keypress)="isNumberKey($event)">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">
            Aucun client :
          </label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            <mat-checkbox class="example-margin" color="primary" [(ngModel)]="transporteur.isAucunClient"
                          (ngModelChange)="changeClient();"></mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-3 champ" style="padding:0px">
            Recherche du client :
          </label>
          <div class="col-sm-9 champ" style="padding-right: 0px"
               [ngClass]="{'disabledbutton': transporteur.isAucunClient}">
            <app-autocomplete [placeholder]="''" (searchfunction)="searchClient($event)"
                              (selectfunction)="setClient($event)" [results]="dataClient" [highlight]="true"
                              [label]="''"  [selectvalue]="true"
                              [dropdownclass]="mindropdown" [id]="'modedepaie clientRefact'"></app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" *ngIf="transporteur.clientFact && transporteur.clientFact.id">
          <label class="col-sm-3 champ" style="padding:0px">
            Client :
          </label>
          <div class="col-sm-9 champ" style="padding-right: 0px">
            {{ transporteur.clientFact ? transporteur.clientFact.codeClient + ' / ' : '' }}
            {{ transporteur.clientFact ? transporteur.clientFact.nomClient : '' }}
          </div>
        </div>
        <!--div class="form-group items col-sm-12" *ngIf="transporteur.client && transporteur.client.id">
            <label class="col-sm-3 champ" style="padding:0px">
                Code client :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
                {{ transporteur.client ? transporteur.client.codeClient : '' }}
            </div>
        </div>
        <div class="form-group items col-sm-12" *ngIf="transporteur.client && transporteur.client.id">
            <label class="col-sm-3 champ" style="padding:0px">
                Enseigne :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
                {{ transporteur.client ? transporteur.client.enseigne : '' }}
            </div>
        </div>
        <div class="form-group items col-sm-12" *ngIf="transporteur.client && transporteur.client.id">
            <label class="col-sm-3 champ" style="padding:0px">
                Ville :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
                {{ transporteur.client ? transporteur.client.ville : '' }}
            </div>
        </div-->
      </div>
    </div>
  </div>
</div>

<app-tarif-transporteur *ngIf="afficherWinTarifTransporteur" [setTransporteur]="transporteur || {}"
                        (callback)="retourWinPrincipale()"></app-tarif-transporteur>
<app-transporteur-logo *ngIf="afficherWinTransporteurLogo" [setTransporteur]="transporteur || {}"
                       (callback)="retourWinPrincipale()"></app-transporteur-logo>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
      </button>
    </div>
  </div>
</ng-template>
